import m from "../../../../geodata/es2015/region/usa/vtLow";
window.am4geodata_region_usa_vtLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/vtLow.js
// module id = null
// module chunks = 